import React, {useEffect} from 'react'
import "./Upper.scss"

export default function Upper() {

    useEffect(() => {
        // const parallax = document.querySelector(".upper")
        const paraTitle = document.querySelector(".title")
        window.addEventListener("scroll" , function(){
            let offset = window.pageYOffset
            // parallax.style.backgroundPositionY = offset * 0.7 + "px"
            if(offset > 1000) return;
            let calc = 85 + (offset * 0.7)
            paraTitle.style.transform = `translateY(${calc+ "px"})`;
        })
    }, [])

    const startScrolling = () => {
        let video = document.querySelector(".video-page");
        video.scrollIntoView({behavior: "smooth", block: "center", inline: "center"});
    }

    return (
        <section className="upper">
            <div className="bg-upper"></div>
            <div className="title"></div>
            <div className="soldiers"></div>
            <div className="arrow-wrapper" onClick={() => startScrolling()}>
                <div className="arrow"></div>
            </div>
            <div className="upper_credit"></div>
        </section>
    )
}
